<div>

  <section class="form-tasklist">
    <mat-accordion class="retrofit-headers-align">

      <!--Contractor info-->
      <mat-expansion-panel
        [expanded]="viewApprovalTask === 0"
        (opened)="setApprovalTask(0)">
        <mat-expansion-panel-header
          [collapsedHeight]="'60px'"
          [expandedHeight]="'60px'">
          <mat-panel-title>
            <div>
              @switch (taskRetrofitContractorStatus.toLowerCase()) {
                @case ('pending') {
                  <mat-icon class="retrofit-task-icon primary"><i class="fa-solid fa-square-poll-horizontal fa-sm"></i></mat-icon>
                }
                @case ('selected') {
                  <mat-icon class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
                }
                @case ('rejected') {
                  <mat-icon class="retrofit-task-icon rejected"><i class="fa-solid fa-triangle-exclamation fa-sm"></i></mat-icon>
                }
                @case ('updated') {
                  <mat-icon class="retrofit-task-icon accepted"><i class="fa-solid fa-cloud-arrow-up fa-sm"></i></mat-icon>
                }
              }
            </div>
            <div>
              <div class="retrofit-task-name">{{taskRetrofitContractorTitle}}</div>
              <span>
                @switch (taskRetrofitContractorStatus.toLowerCase()) {
                  @case ('pending') {
                    <small class="retrofit-task-status"
                      >
                      Waiting for information
                    </small>
                  }
                  @case ('rejected') {
                    <small class="retrofit-task-status"
                      >
                      Action required
                    </small>
                  }
                  @case ('selected') {
                    <small class="retrofit-task-status accepted"
                      >
                      Completed
                    </small>
                  }
                  @default {
                    <small class="retrofit-task-status"
                      >
                      {{taskRetrofitContractorStatus}}
                    </small>
                  }
                }
              </span>
            </div>
          </mat-panel-title>
          <mat-panel-description fxShow.gt-sm="true" fxShow="false">
            <span class="retrofit-task-summary todo">
              {{taskRetrofitContractorSummary}}
            </span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="retrofit-task-body">
          <div fxLayout="row" fxLayout.lt-md="column wrap">
            <div fxFlex='75%'>
              <ebb-portal-contractor-form
                [application]="application"
                [taskBuildingPermit]="taskBuildingPermit"
                [task]="taskBuildingPermit"
                (emitContractorUpdateEvent)="onEmitContractorUpdate($event)">
                (emitContractorFileUploadEvent)="onEmitContractorFileUploadEvent($event)"
                (emitBidInvoiceFileUploadEvent)="onEmitBidInvoiceFileUploadEvent($event)">
              </ebb-portal-contractor-form>
            </div>

            <div fxFlex='25%'>
              <p class="retrofit-task-help-title" fxShow fxHide.lt-md>
                Help
              </p>

              <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>

              @for (helpLink of helpByTopic('construction'); track helpLink) {
                <div>
                  <a class="retrofit-task-help-section-link"
                    href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                    {{helpLink.linkText}}
                  </a>
                </div>
              }
            </div>
          </div>
        </div>

      </mat-expansion-panel>

      <!--Permit info-->
      @if (taskBuildingPermit) {
        <mat-expansion-panel
          [expanded]="viewApprovalTask === 1"
          (opened)="setApprovalTask(1)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
            <mat-panel-title>
              <mat-icon class="retrofit-task-icon"
                  [ngClass]="{'accepted':
                                (taskBuildingPermit.statusCode === 700000001 || taskBuildingPermit.statusCode === 700000003),
                              'rejected': taskBuildingPermit.statusCode === 700000002,
                              'primary': true  }">
                <div [innerHTML]="loadTaskStatusIconHtml('permit', taskBuildingPermit.statusCode)"></div>
              </mat-icon>
              <div>
                <div class="retrofit-task-name">{{taskBuildingPermit.name}}</div>
                <small class="retrofit-task-status">
                  {{loadTaskStatusValue('permit', taskBuildingPermit.statusCode)}}
                </small>
              </div>
            </mat-panel-title>
            <mat-panel-description fxShow.gt-sm="true" fxShow="false">
              <span class="retrofit-task-summary todo">
                @if (taskBuildingPermit.statusCode === 700000000 || !application.permitIssuer) {
                  <span>
                    {{taskBuildingPermit.userPrompt}}
                  </span>
                }
                @if (application.permitIssuer && application.permitIssuer.length > 0) {
                  <span>
                    {{application.permitIssuer}} ({{application.permitNumber}})
                  </span>
                }
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
              <div fxFlex='75%'>
                <ebb-portal-file-list
                  [context]="'Review'"
                  [title]="'Building Permit Files'"
                  [application]="application"
                  [task]="taskBuildingPermit"
                  (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                </ebb-portal-file-list>
                <ebb-portal-permit-form
                  [application]="application"
                  [task]="taskBuildingPermit"
                  [permitPlanTypeOptions]="permitPlanTypeOptions"
                  (emitPermitInfoChangeEvent)=onEmitPermitUpdate($event)>
                </ebb-portal-permit-form>
                <!-- Moved inline form to child component -->
              </div>
              <div fxFlex='25%'>
                <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>
                <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                @for (helpLink of helpByTopic('permit'); track helpLink) {
                  <div div>
                    <a class="retrofit-task-help-section-link"
                      href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                      {{helpLink.linkText}}
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }

      <!--Permit signoff-->
      @if (taskPermitSignoff) {
        <mat-expansion-panel
          [expanded]="viewApprovalTask === 2"
          (opened)="setApprovalTask(2)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
            <mat-panel-title>
              <mat-icon class="retrofit-task-icon"
                      [ngClass]="{'accepted':
                                  (taskPermitSignoff.statusCode === 700000001 || taskPermitSignoff.statusCode === 700000003),
                                  'rejected': taskPermitSignoff.statusCode === 700000002,
                                  'primary': true  }">
                <div [innerHTML]="loadTaskStatusIconHtml('permit', taskPermitSignoff.statusCode)"></div>
              </mat-icon>
              <div>
                <div class="retrofit-task-name">{{taskPermitSignoff.name}}</div>
                <small class="retrofit-task-status">
                  {{loadTaskStatusValue('permit', taskPermitSignoff.statusCode)}}
                </small>
              </div>
            </mat-panel-title>
            <mat-panel-description fxShow.gt-sm="true" fxShow="false">
              <span class="retrofit-task-summary todo">
                {{taskPermitSignoff.userPrompt}}
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-sm="column wrap" fxLayoutGap="40px">
              <div fxFlex='75%'>
                <p class="retrofit-task-item-title">Permit Documents</p>
                <ebb-portal-file-list
                  [context]="'Review'"
                  [title]="'Building Permit Files'"
                  [application]="application"
                  [task]="taskPermitSignoff"
                  (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                </ebb-portal-file-list>
                <div style='margin: 21px 0px;' readonly>
                  <ebb-portal-timespan-form
                    [application]="application"
                    [task]="taskPermitSignoff"
                    (eventEmitRetrofitTimespan)="onEmitTimeSpanFormUpdate($event)">
                  </ebb-portal-timespan-form>
                </div>
              </div>
              <div fxFlex='25%'>
                <p class="retrofit-task-help-title" fxShow fxHide.lt-sm>Help</p>
                @for (helpLink of helpByTopic('permit'); track helpLink) {
                  <div>
                    <a class="retrofit-task-help-section-link"
                      href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                      {{helpLink.linkText}}
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }

      <!--House photos Pre-retrofit-->
      @if (taskHousePhotosPre) {
        <mat-expansion-panel
          [expanded]="viewApprovalTask === 3"
          (opened)="setApprovalTask(3)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
            <mat-panel-title>
              <mat-icon class="retrofit-task-icon"
                  [ngClass]="{'accepted':
                                (taskHousePhotosPre.statusCode === 700000001 || taskHousePhotosPre.statusCode === 700000003),
                              'rejected': taskHousePhotosPre.statusCode === 700000002,
                              'primary': true  }">
                <div [innerHTML]="loadTaskStatusIconHtml('house', taskHousePhotosPre.statusCode)"></div>
              </mat-icon>
              <div>
                <div class="retrofit-task-name">{{taskHousePhotosPre.name}}</div>
                <small class="retrofit-task-status">
                  {{loadTaskStatusValue('house', taskHousePhotosPre.statusCode)}}
                </small>
              </div>
            </mat-panel-title>
            <mat-panel-description  fxShow.gt-sm="true" fxShow="false">
              <span class="retrofit-task-summary todo">
                {{taskHousePhotosPre.userPrompt}}
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
              <div fxFlex='75%'>
                <ebb-portal-photos
                  [application]="application"
                  [task]="taskHousePhotosPre"
                  (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                </ebb-portal-photos>
              </div>
              <div fxFlex='25%'>
                <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>
                <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                @for (helpLink of helpByTopic('photos'); track helpLink) {
                  <div div>
                    <a class="retrofit-task-help-section-link"
                      href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                      {{helpLink.linkText}}
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }

      <!--House photos Post-retrofit-->
      @if (taskHousePhotosPost) {
        <mat-expansion-panel
          [expanded]="viewApprovalTask === 4"
          (opened)="setApprovalTask(4)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
            <mat-panel-title>
              <mat-icon class="retrofit-task-icon"
                      [ngClass]="{'accepted':
                                  (taskHousePhotosPost.statusCode === 700000001 || taskHousePhotosPost.statusCode === 700000003),
                                  'rejected': taskHousePhotosPost.statusCode === 700000002,
                                  'primary': true  }">
                <div [innerHTML]="loadTaskStatusIconHtml('house', taskHousePhotosPost.statusCode)"></div>
              </mat-icon>
              <div>
                <div class="retrofit-task-name">{{taskHousePhotosPost.name}}</div>
                <small class="retrofit-task-status">
                  {{loadTaskStatusValue('house', taskHousePhotosPost.statusCode)}}
                </small>
              </div>
            </mat-panel-title>
            <mat-panel-description fxShow.gt-sm="true" fxShow="false">
                        <span [ngClass]="{
                                'retrofit-task-summary updated': taskHousePhotosPost.statusCodeOptionSet.toLowerCase() === 'approved',
                                'retrofit-task-summary todo': taskHousePhotosPost.statusCodeOptionSet.toLowerCase() !== 'approved'}">
                {{taskHousePhotosPost.userPrompt}}
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
              <div fxFlex='75%'>
                <ebb-portal-photos
                  [application]="application"
                  [task]="taskHousePhotosPost"
                  (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                </ebb-portal-photos>
              </div>
              <div fxFlex='25%'>
                <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>
                <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                @for (helpLink of helpByTopic('photos'); track helpLink) {
                  <div div>
                    <a class="retrofit-task-help-section-link"
                      href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                      {{helpLink.linkText}}
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }

      <!--Crawl space photos Pre-retrofit-->
      @if (taskCrawlspacePhotosPre) {
        <mat-expansion-panel
          [expanded]="viewApprovalTask === 5"
          (opened)="setApprovalTask(5)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
            <mat-panel-title>
              <mat-icon class="retrofit-task-icon"
                  [ngClass]="{'accepted':
                                (taskCrawlspacePhotosPre.statusCode === 700000001 || taskCrawlspacePhotosPre.statusCode === 700000003),
                              'rejected': taskCrawlspacePhotosPre.statusCode === 700000002,
                              'primary': true  }">
                <div [innerHTML]="loadTaskStatusIconHtml('crawlspace', taskCrawlspacePhotosPre.statusCode)"></div>
              </mat-icon>
              <div>
                <div class="retrofit-task-name">{{taskCrawlspacePhotosPre.name}}</div>
                <small class="retrofit-task-status">
                  {{loadTaskStatusValue('crawlspace', taskCrawlspacePhotosPre.statusCode)}}
                </small>
              </div>
            </mat-panel-title>
            <mat-panel-description  fxShow.gt-sm="true" fxShow="false">
              <span class="retrofit-task-summary todo">
                {{taskCrawlspacePhotosPre.userPrompt}}
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
              <div fxFlex='75%'>
                <ebb-portal-photos
                  [application]="application"
                  [task]="taskCrawlspacePhotosPre"
                  (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                </ebb-portal-photos>
              </div>
              <div fxFlex='25%'>
                <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>
                <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                @for (helpLink of helpByTopic('photos'); track helpLink) {
                  <div div>
                    <a class="retrofit-task-help-section-link"
                      href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                      {{helpLink.linkText}}
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }

      <!--Crawlspace photos Post-retrofit-->
      @if (taskCrawlspacePhotosPost) {
        <mat-expansion-panel
          [expanded]="viewApprovalTask === 6"
          (opened)="setApprovalTask(6)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
            <mat-panel-title>
              <mat-icon class="retrofit-task-icon"
                [ngClass]="{'accepted':
                            (taskCrawlspacePhotosPost.statusCode === 700000001 || taskCrawlspacePhotosPost.statusCode === 700000003),
                            'rejected': taskCrawlspacePhotosPost.statusCode === 700000002,
                            'primary': true  }">
                <div [innerHTML]="loadTaskStatusIconHtml('crawlspace', taskCrawlspacePhotosPost.statusCode)"></div>
              </mat-icon>
              <div>
                <div class="retrofit-task-name">{{taskCrawlspacePhotosPost.name}}</div>
                <small class="retrofit-task-status">
                  {{loadTaskStatusValue('crawlspace', taskCrawlspacePhotosPost.statusCode)}}
                </small>
              </div>
            </mat-panel-title>
            <mat-panel-description  fxShow.gt-sm="true" fxShow="false">
              <span class="retrofit-task-summary todo">
                {{taskCrawlspacePhotosPost.userPrompt}}
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-sm="column wrap" fxLayoutGap="25px">
              <div fxFlex='75%'>
                <ebb-portal-photos
                  [application]="application"
                  [task]="taskCrawlspacePhotosPost"
                  (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                </ebb-portal-photos>
              </div>
              <div fxFlex='25%'>
                <p class="retrofit-task-help-title" fxShow fxHide.lt-sm>Help</p>
                @for (helpLink of helpByTopic('photos'); track helpLink) {
                  <div>
                    <a class="retrofit-task-help-section-link"
                      href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                      {{helpLink.linkText}}
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }

      <!--Water heater photos-->
      @if (taskHeaterPhotos) {
        <mat-expansion-panel
          [expanded]="viewApprovalTask === 7"
          (opened)="setApprovalTask(7)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
            <mat-panel-title>
              <mat-icon class="retrofit-task-icon"
                [ngClass]="{'accepted':
                            (taskHeaterPhotos.statusCode === 700000001 || taskHeaterPhotos.statusCode === 700000003),
                            'rejected': taskHeaterPhotos.statusCode === 700000002,
                            'primary': true  }">
                <div [innerHTML]="loadTaskStatusIconHtml('heater', taskHeaterPhotos.statusCode)"></div>
              </mat-icon>
              <div>
                <div class="retrofit-task-name">{{taskHeaterPhotos.name}}</div>
                <small class="retrofit-task-status">
                  {{loadTaskStatusValue('heater', taskHeaterPhotos.statusCode)}}
                </small>
              </div>
            </mat-panel-title>
            <mat-panel-description  fxShow.gt-sm="true" fxShow="false">
              <span class="retrofit-task-summary todo">
                {{taskHeaterPhotos.userPrompt}}
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-sm="column wrap" fxLayoutGap="25px">
              <div fxFlex='75%'>
                <ebb-portal-photos
                  [application]="application"
                  [task]="taskHeaterPhotos"
                  (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                </ebb-portal-photos>
              </div>
              <div fxFlex='25%'>
                <p class="retrofit-task-help-title" fxShow fxHide.lt-sm>Help</p>
                @for (helpLink of helpByTopic('photos'); track helpLink) {
                  <div>
                    <a class="retrofit-task-help-section-link"
                      href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                      {{helpLink.linkText}}
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }
      <!--receipts info-->
      @if (taskReceiptsPre) {
        <mat-expansion-panel [expanded]="viewApprovalTask === 8" id="receipts-info-panel"
          (opened)="setApprovalTask('receipt')">
          <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
            <mat-panel-title>
         <mat-icon class="retrofit-task-icon" [ngClass]="{'accepted':
         (taskReceiptsPre.statusCode === 700000001 || taskReceiptsPre.statusCode === 700000003),
       'rejected': taskReceiptsPre.statusCode === 700000002,
       'primary': true }">
                <div [innerHTML]="loadTaskStatusIconHtml('receipt', taskReceiptsPre.statusCode)"></div>
              </mat-icon>
              <div>
                <div class="retrofit-task-name">{{taskReceiptsPre.name}}</div>
           <small [ngClass]="{'retrofit-task-status accepted': taskReceiptsPre.statusCode === 700000001,
                 'retrofit-task-status': true}">
                  {{loadTaskStatusValue('receipt', taskReceiptsPre.statusCode)}}
                </small>
              </div>
            </mat-panel-title>
            <mat-panel-description fxShow.gt-sm="true" fxShow="false">
              <span class="retrofit-task-summary todo">
                {{taskReceiptsPre.userPrompt}}
                @if (taskReceiptsPre.statusCode === 700000001 || taskReceiptsPre.statusCode === 700000003) {
                  <span
                    class="retrofit-task-summary todo">
                    (uploaded)
                  </span>
                }
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
              <div fxFlex='75%'>
                <p class="retrofit-task-item-title">Retrofit Receipts</p>
                <ebb-portal-file-list [context]="'PreRetrofit'" [title]="'Retrofit Receipts'" [application]="application"
                  [task]="taskReceiptsPre" (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                </ebb-portal-file-list>
                <ebb-portal-receipt-preretrofit-form
                  [application]="application"
                  [task]="taskReceiptsPre"
                  (emitReceiptPreretrofitFormChangeEvent)="onEmitReceiptsPreInfoUpdate($event)">
                </ebb-portal-receipt-preretrofit-form>
              </div>
              <div fxFlex='25%'>
                <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>
                <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                @for (helpLink of helpByTopic('receipts'); track helpLink) {
                  <div div>
                    <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                      {{helpLink.linkText}}
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }
      <!-- Receipts -->
      @if (taskReceiptsPost) {
        <mat-expansion-panel [expanded]="viewApprovalTask === 9" (opened)="setApprovalTask(9)">
          <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
            <mat-panel-title>
        <mat-icon class="retrofit-task-icon" [ngClass]="{
               'accepted':
               (taskReceiptsPost.statusCode === 700000001 || taskReceiptsPost.statusCode === 700000003),
               'rejected': taskReceiptsPost.statusCode === 700000002,
               'primary': true
             }">
                <div [innerHTML]="loadTaskStatusIconHtml('receipt', taskReceiptsPost.statusCode)"></div>
              </mat-icon>
              <div>
                <div class="retrofit-task-name">{{ taskReceiptsPost.name }}</div>
                <small class="retrofit-task-status">
                  {{loadTaskStatusValue('receipt', taskReceiptsPost.statusCode)}}
                </small>
              </div>
            </mat-panel-title>
            <mat-panel-description fxShow.gt-sm="true" fxShow="false">
              <span class="retrofit-task-summary todo">
                {{ taskReceiptsPost.userPrompt }}
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-sm="column wrap" fxLayoutGap="12px">
              <div fxFlex="80%">
                <div style="margin-top: 15px;">
                  <ebb-portal-receipt-list
                    [title]="'Receipts'"
                    [application]="application"
                    [task]="taskReceiptsPost"
                    (emitReceiptUploadEvent)="onEmitDataFormUpdate($event)">
                  </ebb-portal-receipt-list>
                  <div style="margin-top: 32px;">
                    <ebb-portal-receipt-form
                      [application]="application"
                      [listOptionSets]="listOptionSets"
                      [task]="taskReceiptsPost"
                      (emitReceiptFormChangeEvent)="onEmitDataFormUpdate($event)">
                    </ebb-portal-receipt-form>
                  </div>
                </div>
              </div>
              <div fxFlex="20%">
                <p class="retrofit-task-help-title" fxShow fxHide.lt-sm>Help</p>
                @for (helpLink of helpByTopic('receipts'); track helpLink) {
                  <div>
                    <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                      {{ helpLink.linkText }}
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }

      <!--W-9 form-->
      @if (!isContractor() && taskW9form && !isreadonly) {
        <mat-expansion-panel
          [expanded]="viewApprovalTask === 10"
          (opened)="setApprovalTask(10)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
            <mat-panel-title>
              <mat-icon class="retrofit-task-icon"
                  [ngClass]="{'accepted':
                                (taskW9form.statusCode === 700000001 || taskW9form.statusCode === 700000003),
                              'rejected': taskW9form.statusCode === 700000002,
                              'primary': true  }">
                <div [innerHTML]="loadTaskStatusIconHtml('w9form', taskW9form.statusCode)"></div>
              </mat-icon>
              <div>
                <div class="retrofit-task-name">{{taskW9form.name}}</div>
                <small class="retrofit-task-status">
                  {{loadTaskStatusValue('w9form', taskW9form.statusCode)}}
                </small>
              </div>
            </mat-panel-title>
            <mat-panel-description  fxShow.gt-sm="true" fxShow="false">
              <span class="retrofit-task-summary todo">
                {{taskW9form.userPrompt}}
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
              <div fxFlex='75%'>
                <p class="retrofit-task-item-title">W-9 DATA</p>
                <div class="retrofit-form-text">
                  <div [innerHTML]="w9message"></div>
                </div>
                @if ((!application.eventPreliminaryReview ||
                  (application.eventPreliminaryReview && taskW9form.approvalTaskItems[0].statusCode === 700000002)) &&
                  isHomeowner()) {
                  <div style="margin-top: 18px;"
                    >
                    <button mat-stroked-button color="primary"
                      (click)="onClickSubmitW9data()">
                      SUBMIT FORM W-9 DATA
                    </button>
                  </div>
                }
                @if (application.w9DataSubmitted
                  && taskW9form.approvalTaskItems[0].statusCode === 700000002
                  && (taskW9form.approvalTaskItems[0].reasonWhy
                  && taskW9form.approvalTaskItems[0].reasonWhy.length > 0)) {
                  <div style="margin-top: 18px"
                    >
                    <p><span class="warn-text">Action required</span>: {{taskW9form.approvalTaskItems[0].reasonWhy}}</p>
                  </div>
                }
                @if (w9FormSubmitted) {
                  <div class="retrofit-form-inline-icon-with-label-container"
                    >
                    <mat-icon class="retrofit-form-inline-icon-with-label" color="accent">check_circle_outline</mat-icon>
                    <span class="retrofit-form-inline-icon-with-label-text">{{w9FormPayee}} W-9 data submitted on {{w9AuthorizationDate | date: 'M/d/yyyy'}}</span>
                  </div>
                }
              </div>
              <div fxFlex='25%'>
                <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>
                <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                @for (helpLink of helpByTopic('payment'); track helpLink) {
                  <div div>
                    <a class="retrofit-task-help-section-link"
                      href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                      {{helpLink.linkText}}
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }


      <!--Payment authorization form-->
      @if (!isContractor() && taskPaymentAuthorization && !isreadonly) {
        <mat-expansion-panel
          [expanded]="viewApprovalTask === 11"
          (opened)="setApprovalTask(11)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
            <mat-panel-title>
              <mat-icon class="retrofit-task-icon"
            [ngClass]="{'accepted':
                        (taskPaymentAuthorization.statusCode === 700000001 || taskPaymentAuthorization.statusCode === 700000003),
                        'rejected': taskPaymentAuthorization.statusCode === 700000002,
                        'primary': true  }">
                <div [innerHTML]="loadTaskStatusIconHtml('payment', taskPaymentAuthorization.statusCode)"></div>
              </mat-icon>
              <div>
                <div class="retrofit-task-name">{{taskPaymentAuthorization.name}}</div>
                <small class="retrofit-task-status">
                  {{loadTaskStatusValue('payment', taskPaymentAuthorization.statusCode)}}
                </small>
              </div>
            </mat-panel-title>
            <mat-panel-description  fxShow.gt-sm="true" fxShow="false">
              <span class="retrofit-task-summary todo">
                {{taskPaymentAuthorization.userPrompt}}
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
              <div fxFlex='75%'>
                <p class="retrofit-task-item-title">PAYMENT FORM</p>
                <p>Authorize payment to either the homeowner or contractor.</p>
                @if (isHomeowner() &&
                  (!application.eventApplicationSubmitted ||
                  (application.eventApplicationSubmitted && taskPaymentAuthorization.approvalTaskItems[0].statusCode === 700000002))) {
                  <div
                    style="margin-top: 18px;">
                    <button mat-stroked-button color="primary"
                      (click)="onClickSubmitPaymentAuthorization()">
                      COMPLETE PAYMENT AUTHORIZATION
                    </button>
                  </div>
                }
                @if (application.eventApplicationSubmitted
                  && taskPaymentAuthorization.approvalTaskItems[0].statusCode === 700000002
                  && (taskPaymentAuthorization.approvalTaskItems[0].reasonWhy
                  && taskPaymentAuthorization.approvalTaskItems[0].reasonWhy.length > 0)) {
                  <div style="margin-top: 18px"
                    >
                    <p><span class="warn-text">Action required</span>: {{taskPaymentAuthorization.approvalTaskItems[0].reasonWhy}}</p>
                  </div>
                }
                @if (authorizedPaymentSubmitted) {
                  <div class="retrofit-form-inline-icon-with-label-container"
                    >
                    <mat-icon class="retrofit-form-inline-icon-with-label" color="accent">check_circle_outline</mat-icon>
                    <span class="retrofit-form-inline-icon-with-label-text">{{authorizedPaymentTo}} authorized</span>
                  </div>
                }
              </div>
              <div fxFlex='25%'>
                <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>
                <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                @for (helpLink of helpByTopic('payment'); track helpLink) {
                  <div div>
                    <a class="retrofit-task-help-section-link"
                      href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                      {{helpLink.linkText}}
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }

    </mat-accordion>
  </section>

  <br/>

</div>
